import { defineStore } from 'pinia';
import { HelloResponse } from '../globals/ServerManager';

// eslint-disable-next-line import/prefer-default-export
export const useCustomerOnboardingStore = defineStore({
	id: 'customerOnboarding',
	state: () => ({
		/**
		 * Poszczególne ekrany onboardingu do wyświetlenia.
		 */
		steps: [] as { name: string; percentageValue: number; }[],

		/**
		 * Ile razy został wyświetlony ekran "Dzień dobry w Oferteo"?
		 */
		displayCount: 0,

		/**
		 * Szczegóły profilu użytkownika, które są wykorzystywane do wyświetlania ekranów onboardingowych.
		 * Głównie chodzi o to, czy użytkownik ma zdjęcia, opis, opinie, itp. oraz statystyki pokazywane
		 * na kafelku znajdującym się na powitalnym/końcowym ekranie.
		 */
		profileDetails: {
			yearsOnMarket: 0,
			offersCount: 0,
			hasPhotos: false,
			hasDescription: false,
			hasReviews: false,
		},

		/**
		 * Czy konto użytkownika wymaga weryfikacji w danej sesji?
		 */
		needsVerification: false,
	}),
	actions: {
		/**
		 * Uaktualnia dane dotyczące ekranów onboardingowych z początkowej odpowiedzi serwera.
		 */
		update(rsvp: HelloResponse) {
			if (!rsvp.onboarding || !rsvp.user) { return; }
			this.steps = rsvp.onboarding.onboardingSteps;
			this.displayCount = rsvp.onboarding.allowDisablingGoodMorning ? 10 : 0;
			this.profileDetails = {
				yearsOnMarket: rsvp.user.yearsOnMarket || 0,
				offersCount: rsvp.user.placedOffersCount || 0,
				hasPhotos: rsvp.user.hasPhotos || false,
				hasDescription: rsvp.user.hasDescription || false,
				hasReviews: rsvp.user.hasMarks || false,
			};

			// Wyświetl informację o konieczności weryfikacji Autenti zamiast onboardingu.
			if (rsvp.flags.includes('needsVerification')) {
				this.needsVerification = true;
			}
		},

		/**
		 * Sprawdza, czy na danym URL-u można wyświetlić ekran onboardingowy zamiast zawartości strony.
		 */
		canShowOnboarding(href: string) {
			if (href.includes('/moje-zapytania')) { return false; }
			if (this.needsVerification && href.includes('/konto') && !href.includes('/zapytanie')) { return true; }
			if (!this.steps.length) { return false; }
			return (href.includes('/zapytania') || href.includes('/kontakty') || href.endsWith('/konto'));
		},
	},
});
